import { useContext } from 'react';
import { ThemeContext, type ThemeContextValue } from './ThemeProvider.js';

export function useTheme(): ThemeContextValue {
  const value = useContext(ThemeContext);
  if (value === null) {
    throw new Error('useTheme must be used inside <ThemeProvider>');
  }
  return value;
}
